﻿import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import { unsafeCharRegex } from 'wbm-inputs';

export type SearchInputProps = {
    placeHolder: string,
    onSearch: (val: string) => void
}

export const SearchInput = (props: SearchInputProps) => {
    const [value, setValue] = useState('');

    const testRegex = (val) => {
        let pattern = unsafeCharRegex;
        let regex = new RegExp(pattern);
        let test = regex.test(val);
        return test;
    }

    const updateValue = (e) => {
        let val = e.target.value;
        if (testRegex(val)) {
            e.preventDefault();
        } else {
            setValue(val);
        }
    }

    const onKeyPress = (e) => {
        let key = e.key;
        if (testRegex(key)) {
            e.preventDefault();
        }
    }

    const onKeyDownHandler = (ev) => {
        let keycode = ev.keyCode ? ev.keyCode : ev.which;
        if (keycode === 13 || ev.key === "Enter") {
            props.onSearch(value);
        }
    }

    return (
        <div className='search-input'>
            <span className="search-icon"><SearchIcon onClick={() => props.onSearch(value)} /></span>
            <InputMask
                type="text"
                className={"form-control"}
                placeholder={props.placeHolder}
                onChange={(ev) => updateValue(ev)}
                onKeyPress={(ev) => onKeyPress(ev)}
                onKeyDown={(ev) => onKeyDownHandler(ev)}
                value={value}
            />
            <div className='close-icon'><CloseIcon onClick={() => setValue('')} /></div>
        </div>
    );
};